import { Link } from 'react-router-dom'
import Icon from '@forwardflow/ui/Icons'
import { ForgotPasswordForm } from '@forwardflow/forms'
import { useState } from 'react'

export const ForgotPasswordComponent = () => {
   const [isSubmitted, setIsSubmitted] = useState(false)
   const [email, setEmail] = useState('')
   const handleFormSubmit = (submitted: boolean, email?: string) => {
      if (submitted) {
         setIsSubmitted(true)
         setEmail(email || '')
      }
   }
   return (
      <>
         <div className="flex flex-col items-center justify-center w-full h-screen relative -translate-y-20">
            <Link
               className="bg-white/10 transition-all hover:bg-white/20 w-[200px] h-12 flexc rounded-full md:absolute mt-7 md:mt-0 top-10 right-4 md:right-16"
               to="/signup"
            >
               Sign up
            </Link>
            <div className="flex gap-x-[18px] items-center my-7 relative">
               <Link
                  to="/signin"
                  className="absolute cursor-pointer -left-[70px]"
               >
                  <Icon name="back-arrow-circle" />
               </Link>
               <h1 className="text-[22px] font-medium">Forgot Password?</h1>
            </div>
            <h2 className="text-[12px] md:text-[14px] mb-[50px] text-[#C9C9C9]">
               Verify your email to reset password
            </h2>
            {!isSubmitted ? (
               <ForgotPasswordForm onSubmit={handleFormSubmit} />
            ) : (
               <div className="w-full max-w-[450px] mx-auto bg-black/40 border border-white/20 rounded-xl p-8 flex flex-col justify-center items-center">
                  <Icon name="Mail" className="mx-auto mb-5" />
                  <h2 className="text-[20px] font-semibold mb-10">
                     Reset Password link sent !
                  </h2>
                  <div className="text-[14px] flex flex-col items-center">
                     <p className="mb-4 text-white/70">
                        We emailed a reset password link
                     </p>
                     <p>{email}</p>
                  </div>
               </div>
            )}
         </div>
      </>
   )
}
